
export enum ApplicationSiteGroup {
  CB = 'CB',
  CK = 'CK',
  GCS = 'GCS',
}

export enum PageType {
  CB_BlankGiftCardsPage = 'CB_BlankGiftCardsPage',
  CB_Blog = 'CB_Blog',
  CB_BlogArticle = 'CB_BlogArticle',
  CB_BusinessFormPage = 'CB_BusinessFormPage',
  CB_BusinessFormPage_v2 = 'CB_BusinessFormPage_v2',
  CB_ContactsPage = 'CB_ContactsPage',
  CB_GiftCardActivationPage = 'CB_GiftCardActivationPage',
  CB_GiftCardActivationThankYouPage = 'CB_GiftCardActivationThankYouPage',
  CB_GivingMomentsOverviewPage = 'CB_GivingMomentsOverviewPage',
  CB_GivingMomentsPage = 'CB_GivingMomentsPage',
  CB_HomePage = 'CB_HomePage',
  CB_HomePage_v2 = 'CB_HomePage_v2',
  CB_LandingPage = 'CB_LandingPage',
  CB_LocationsOverviewPage = 'CB_LocationsOverviewPage',
  CB_ProductsOverviewPage = 'CB_ProductsOverviewPage',
  CB_RedeemB2BResultPage = 'CB_RedeemB2BResultPage',
  CB_RedeemCheckPage = 'CB_RedeemCheckPage',
  CB_RedeemResultPage = 'CB_RedeemResultPage',
  CB_TermsConditionsPage = 'CB_TermsConditionsPage',
  CB_UserHomePage = 'CB_UserHomePage',
  ConfirmationPage = 'ConfirmationPage',
  DoublerThankYouPage = 'DoublerThankYouPage',
  GiftCardBrand = 'GiftCardBrand',
  GiftcardCategory = 'GiftcardCategory',
  GiftcardProduct = 'GiftcardProduct',
  Restaurant = 'Restaurant',
}
